export default __webpack_public_path__ + "static/banner-e-1d41d826c048c043e2c02da923954855.png";